import * as React from 'react';
import StoreGroupFinderContainer from '../../components/StoreGroupFinder/StoreGroupFinderContainer.js';
import '../../context/StoreFinder/context.js';
import { StoreFinderProvider } from '../../context/StoreFinder/provider.js';
import '../../context/StoreFinderSlots/context.js';

const StoreGroupRoot = ({ groupName , hideEmail , hidePhone , stores , storeSearchFilters , urls ,  })=>{
    return /*#__PURE__*/ React.createElement(StoreFinderProvider, {
        googleMapsId: "google-maps-container",
        withUrlParams: true,
        hidePhone: hidePhone,
        hideEmail: hideEmail,
        initialStores: stores !== null && stores !== void 0 ? stores : undefined,
        urls: urls
    }, /*#__PURE__*/ React.createElement("style", {
        jsx: true,
        global: true
    }, `
        .banner,
        .notification-bar {
          position: relative;
          z-index: 100;
        }
      `), /*#__PURE__*/ React.createElement(StoreGroupFinderContainer, {
        groupName: groupName,
        storeSearchFilters: storeSearchFilters,
        urls: urls
    }));
};

export { StoreGroupRoot as default };
//# sourceMappingURL=StoreGroupRoot.js.map
